var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ns-select no-border" }, [
    _c(
      "div",
      { class: { "ns-select-div": _vm.hasArrows } },
      [
        _vm.hasArrows
          ? _c(
              "div",
              {
                class: _vm.arrowClassesLeft,
                on: {
                  click: function($event) {
                    _vm.reverseArrowControls ? _vm.next() : _vm.previous()
                  }
                }
              },
              [
                _c("NsIcon", {
                  attrs: {
                    "icon-name": "icon-circle-chevron-left",
                    size: "custom"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.autoCompleteValue,
              expression: "autoCompleteValue"
            }
          ],
          staticClass: "select-auto-fill-input",
          attrs: {
            tabindex: "-1",
            name: _vm.name,
            autocomplete: _vm.autocomplete
          },
          domProps: { value: _vm.autoCompleteValue },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.autoCompleteValue = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "VSelect",
          _vm._b(
            {
              attrs: {
                "background-color": "gray",
                attach: "",
                disabled: _vm.disabled,
                error: !!_vm.errorMessages,
                "error-messages": _vm.errorMessages,
                items: _vm.items,
                "item-text": _vm.itemText,
                "item-value": _vm.itemValue,
                label: _vm.label,
                "menu-props": _vm.menuProps,
                placeholder: _vm.placeholder,
                required: _vm.required,
                rules: _vm.rules,
                readonly: _vm.readOnly,
                "validate-on-blur": _vm.validateOnBlur
              },
              on: {
                input: _vm.selectChanged,
                blur: function($event) {
                  return _vm.$emit("blur", _vm.inputValue)
                },
                focus: function($event) {
                  return _vm.$emit("focus", _vm.inputValue)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function() {
                    return [
                      !_vm.readOnly
                        ? _c("NsIcon", {
                            attrs: {
                              "icon-name": "icon-chevron-down",
                              height: "20",
                              width: "20"
                            }
                          })
                        : _c("span")
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.inputValue,
                callback: function($$v) {
                  _vm.inputValue = $$v
                },
                expression: "inputValue"
              }
            },
            "VSelect",
            _vm.$attrs,
            false
          )
        ),
        _vm._v(" "),
        _vm.hasArrows
          ? _c(
              "div",
              {
                class: _vm.arrowClassesRight,
                on: {
                  click: function($event) {
                    _vm.reverseArrowControls ? _vm.previous() : _vm.next()
                  }
                }
              },
              [
                _c("NsIcon", {
                  attrs: {
                    "icon-name": "icon-circle-chevron-right",
                    size: "custom"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }